import { useMutation } from 'react-query';
import { NotificationAdapter } from 'src/backoffice-app-code/externalServices/adapters/NotificationServiceAdapter';
import { useDefaultRQConfig } from 'src/backoffice-app-code/libs/reactQuery/hooks/reactQueryBase';
import { getServerErrorMessage } from 'src/backoffice-app-code/utils/errorUtils';
import { DIContext } from '../../context';
import { SendNotificationToAllUsersFormData } from '../../models';

export const useSendNotificationToAllUsers = () => {
  const { deviceRepository } = DIContext;
  const { EnqueueMessage } = NotificationAdapter();
  const config = useDefaultRQConfig('useSendNotificationToAllUsers');

  const { isLoading, error, mutateAsync } = useMutation(
    async (data: SendNotificationToAllUsersFormData) => {
      const response = await deviceRepository.sendNotificationToAllUsers(data);
      return response;
    },
    {
      ...config,
      onSuccess: () => {
        EnqueueMessage('Uspešno ste poslali notifikaciju korisnicima', 'success');
      },
    }
  );

  return {
    sendNotification: mutateAsync,
    errorMessage: error ? getServerErrorMessage(error) : undefined,
    isLoading,
  };
};
